import { jsx as i } from "react/jsx-runtime";
import { c as t } from "../../../clsx-OuTLNxxd.js";
const r = "_divider_dlgq8_29", c = "_dashed_dlgq8_61", d = {
  divider: r,
  "small-space": "_small-space_dlgq8_35",
  "medium-space": "_medium-space_dlgq8_38",
  "no-space": "_no-space_dlgq8_41",
  "with-text": "_with-text_dlgq8_44",
  dashed: c,
  "divider-text": "_divider-text_dlgq8_70",
  "dialog-overlay-show": "_dialog-overlay-show_dlgq8_1",
  "dialog-content-show": "_dialog-content-show_dlgq8_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_dlgq8_1"
};
function m({ className: s, text: e, dashed: l, space: a = "medium", ...o }) {
  const _ = t(
    d.divider,
    d[`${a}-space`],
    e && d["with-text"],
    l && d.dashed,
    s
  );
  return /* @__PURE__ */ i("div", { className: _, role: "separator", "aria-label": e || "divider", ...o, children: e && /* @__PURE__ */ i("span", { className: d["divider-text"], children: e }) });
}
export {
  m as Divider
};
